// Lib
import React from 'react';

// Hooks
import { useElementTiptapContent } from '../../../common/tiptap/conversion/elementConversion/useElementTiptapContent';

// Components
import CaptionTiptapEditor from './tiptap/CaptionTiptapEditor';

// Types
import { CaptionProps } from './captionComponentTypes';
import { DocumentType } from '../../../common/tiptap/conversion/elementConversion/elementConversion';
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';

const Caption = (props: CaptionProps): JSX.Element | null => {
    const {
        element,
        textContent,
        currentEditorId,
        isEditable,
        isEditing,
        isSingleSelected,
        isFocusedForegroundElement,
        isModalView,
        spellCheck,
        captionVisible,
        placeholder,
        style,
        padTop,
        startEditing,
        saveCaptionContent,
        onEmptyBackspace,
        onDoubleClick,
    } = props;

    if (!captionVisible) return null;

    const elementId = getElementId(element);
    const tiptapContent = useElementTiptapContent(textContent, elementId, DocumentType.caption);

    return (
        <CaptionTiptapEditor
            element={element}
            textContent={tiptapContent}
            currentEditorId={currentEditorId}
            isEditable={isEditable}
            isEditing={isEditing}
            isSingleSelected={isSingleSelected}
            isFocusedForegroundElement={isFocusedForegroundElement}
            isModalView={isModalView}
            spellCheck={spellCheck}
            placeholder={placeholder}
            style={style}
            padTop={padTop}
            startEditing={startEditing}
            saveCaptionContent={saveCaptionContent}
            onEmptyBackspace={onEmptyBackspace}
            onDoubleClick={onDoubleClick}
        />
    );
};

export default Caption;
